import { render, staticRenderFns } from "./PopulationEdit.vue?vue&type=template&id=4b4e5d92"
import script from "./PopulationEdit.vue?vue&type=script&lang=js"
export * from "./PopulationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports